import { http, HttpResponse } from 'msw';

import { ClientListResponse } from 'shared/openapi/models/client-list-response';

export default http.get('/api/WEB/admin/clients', () =>
  HttpResponse.json<ClientListResponse>({
    clients: [],
    page: { currentPage: 0, totalPages: 0, totalElements: 0 },
  })
);
